import React from "react";
import { Link } from "react-router-dom";

import "./style.less";

// application footer
const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <>
      <footer className="layout-footer">
        <div className="footer-divider" />

        <div className="footer-copyright-div">© {currentYear} Syngenta</div>

        <div className="layout-footer-content">
          <Link to={"/unternehmen/impressum"} className="footer-link" target="_blank" rel="noopener">
            Impressum
          </Link>
          <Link to={"/unternehmen/nutzungsbedingungen"} className="footer-link" target="_blank" rel="noopener">
            Nutzungsbedingungen
          </Link>
          <Link to={"/unternehmen/datenschutz"} className="footer-link" target="_blank" rel="noopener">
            Datenschutz
          </Link>
          <Link to={"/unternehmen/cookie-richtlinie"} className="footer-link" target="_blank" rel="noopener">
            Cookie-Richtlinie
          </Link>
          <Link to={"https://www.syngenta.de"} className="footer-link" target="_blank" rel="noopener">
            Syngenta
          </Link>
        </div>
      </footer>
    </>
  );
};

export default Footer;
